import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import Footer from "../src/components/footer/footer";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
  <React.StrictMode>
    <link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,100..900;1,100..900&display=swap"
/>

    <App />
    <Footer />
  </React.StrictMode>
);

reportWebVitals();
